// The tabs of /admin. The chosen tab is the URL's `tab` search value: one of these words and nothing else.
export const TABS = ['accounts', 'invites', 'tokens', 'audit', 'sources', 'suppression', 'objections', 'onboarding', 'notice'] as const
export type Tab = (typeof TABS)[number]

export function parseSearch(search: Record<string, unknown>): { tab?: Tab } {
  return typeof search.tab === 'string' && (TABS as readonly string[]).includes(search.tab) ? { tab: search.tab as Tab } : {}
}
